export const messages = {
  en: {
    maintainanceStandard: {
      search: {
        title: 'Search Conditions',
        standardName: 'Please select maintenance item'
      },
      list: {
        title: 'Maintenance Standard'
      },
      table: {
        standardName: 'Maintenance Standard',
        itemCount: 'Inspection Items',
        item: 'Items',
        remark: 'Remark',
        createTime: 'Create Time'
      },
      form: {
        standardName: 'Maintenance Item',
        remark: 'Remark'
      },
      placeholder: {
        standardName: 'Required, please fill in the maintenance item',
        remark: 'Required, please fill in the remark'
      },
      rules: {
        standardName: 'Maintenance item cannot be empty',
        standardNameMax: 'Maintenance item cannot exceed 256 characters',
        remark: 'Remark cannot be empty',
        remarkMax: 'Remark cannot exceed 512 characters',
        standardId: 'ID cannot be empty'
      },
      add: {
        title: 'Add Maintenance Standard'
      },
      edit: {
        title: 'Edit Maintenance Standard'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this maintenance standard?'
      },
      message: {
        addSuccess: 'Add successfully',
        addFailed: 'Add failed',
        editSuccess: 'Edit successfully',
        editFailed: 'Edit failed',
        deleteSuccess: 'Delete successfully',
        deleteFailed: 'Delete failed',
        fetchError: 'Failed to fetch data'
      }
    }
  },
  zh: {
    maintainanceStandard: {
      search: {
        title: '查询条件',
        standardName: '请选择保养项目'
      },
      list: {
        title: '保养标准'
      },
      table: {
        standardName: '保养标准',
        itemCount: '检查项',
        item: '检查项',
        remark: '备注',
        createTime: '创建时间'
      },
      form: {
        standardName: '保养项目',
        remark: '备注'
      },
      placeholder: {
        standardName: '必填，请填写保养项目',
        remark: '必填，请填写备注'
      },
      rules: {
        standardName: '保养项目不能为空',
        standardNameMax: '保养项目不能超过256个字符',
        remark: '备注不能为空',
        remarkMax: '备注不能超过512个字符',
        standardId: '编号不能为空'
      },
      add: {
        title: '添加保养标准'
      },
      edit: {
        title: '修改保养标准'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除保养标准?'
      },
      message: {
        addSuccess: '添加成功',
        addFailed: '添加失败',
        editSuccess: '修改成功',
        editFailed: '修改失败',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        fetchError: '获取数据失败'
      }
    }
  }
}